import React from 'react'
import api from "../../../service/api";
import './index.scss';
import LazyLoadImg from '../../aelComponent/LazyLoadImg';

const RecommendArticlesOthers = (props) => {
  const { data, haveLine, index } = props || {}
  if (!data) return null
  return (
    <a href={data.legoId ? `/art/${data.legoId}/` : `/article/${data.id}/`} className='recommendArticlesOthers'>
      <div
        className='recommendArticlesOthersContainer'
        id={data.id}
        data-index={index}
        data-pid='recommendArticles'
      >
        <div className="recommendArticlesOthers_top">
          <div className='r_a_f_left'>
            <LazyLoadImg image={api.getResource(data.image)} alt={`${data.title || ''} ${data.subtitle} ${data.authorLabel} article img`} className='r_a_f_img'></LazyLoadImg>
          </div>
          <div className='r_a_f_main'>
            <div className='r_a_f_main_right'>
              <div className='r_a_f_m_tagAndDate'>
                <div className='r_a_f_m_tag'>
                  {
                    // index===0 ? <div className='r_a_f_m_tag_hot'>热</div> : <div className='r_a_f_m_tag_new'>新</div>
                  }
                </div>
                <div className='r_a_f_m_date'>
                  {data.merchant ? (
                    <div className="r_a_f_m_data_merchant">{data.merchant}</div>
                  ) : null}
                  <div className="r_a_f_m_data_dat">{data.date}</div>
                </div>
              </div>
              <h3 className='r_a_f_m_tit'>{data.title}</h3>
              <div className='r_a_f_m_subtit'>{data.subtitle}</div>
              <div className='r_a_f_m_expireAndAuther'>
                {
                  data.expiresAt ? (data.expiresAt <= new Date().getTime()) ? <div className='r_a_f_m_expiresAt r_a_f_m_expiresAtT'>已过期</div>
                    : <div className='r_a_f_m_expiresAt r_a_f_m_expiresAtF'>限时</div> : <div></div>
                }
                <div className='r_a_f_m_auther'>{data.authorLabel}</div>
              </div>
            </div>
          </div>
        </div>
        {
          haveLine && <div className="recommendArticlesOthers_line"></div>
        }
      </div>
    </a>
  )
}

export default RecommendArticlesOthers;